import { PublicClientApplication } from "@azure/msal-browser";

export const msalInstance = new PublicClientApplication({
    auth: {
        clientId: `${process.env.REACT_APP_MICROSOFT_CLIENTID}`,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MICROSOFT_TENET}`,
        redirectUri: `${window.location.origin}/auth/azure/callback`,
    },
});
